import { render, staticRenderFns } from "./IndexReport.vue?vue&type=template&id=1dfb6320&scoped=true&lang=pug&"
import script from "./IndexReport.vue?vue&type=script&lang=ts&"
export * from "./IndexReport.vue?vue&type=script&lang=ts&"
import style0 from "./IndexReport.vue?vue&type=style&index=0&id=1dfb6320&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfb6320",
  null
  
)

export default component.exports